import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import PostPageHeader from "../PostPageHeader";
import PostPageBreadcrumbs from "../PostPageBreadcrumbs";
import PostPageCard from "../PostPageCard";
import PostPageComments from "../PostPageComments";
import PostPagePageBanner from "../PostPagePageBanner";
import PostPageViewsTodoListTodoList from "./PostPageViewsTodoListTodoList";
const PostPageViewsTodoListMain = (props)=>{
    const { todoList  } = props;
    const { rootTopicOrSelf , rootPost , breadcrumbsList , commentCount , comments  } = todoList;
    const rootOwner = rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.owner;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            (rootPost === null || rootPost === void 0 ? void 0 : rootPost.breadcrumbsList) && rootOwner && /*#__PURE__*/ _jsx(PostPageHeader, {
                breadcrumbsList: rootPost === null || rootPost === void 0 ? void 0 : rootPost.breadcrumbsList,
                owner: rootOwner,
                previous: todoList.previous,
                next: todoList.next,
                append: breadcrumbsList ? /*#__PURE__*/ _jsx(PostPageBreadcrumbs, {
                    breadcrumbsList: breadcrumbsList
                }) : undefined
            }),
            /*#__PURE__*/ _jsx(PostPagePageBanner, {
                item: todoList,
                negativeMargins: true
            }),
            /*#__PURE__*/ _jsx(PostPageCard, {
                children: /*#__PURE__*/ _jsx(PostPageViewsTodoListTodoList, {
                    todoList: todoList
                })
            }),
            /*#__PURE__*/ _jsx(PostPageComments, {
                item: todoList,
                commentCount: commentCount,
                comments: comments.nodes
            })
        ]
    });
};
export default PostPageViewsTodoListMain;
